const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 38 38",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6300_99035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6300_99035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7875 18.4368L22.7299 13.3792L24.4229 11.7258L27.7875 15.0904L34.5167 8.36123L36.1851 10.0542L27.7875 18.4368ZM14.25 18.5128C12.7216 18.5128 11.4158 17.9713 10.3328 16.8883C9.24983 15.8055 8.70833 14.4998 8.70833 12.9711C8.70833 11.4427 9.24983 10.1369 10.3328 9.05394C11.4158 7.97094 12.7216 7.42944 14.25 7.42944C15.7784 7.42944 17.0842 7.97094 18.1672 9.05394C19.2502 10.1369 19.7917 11.4427 19.7917 12.9711C19.7917 14.4998 19.2502 15.8055 18.1672 16.8883C17.0842 17.9713 15.7784 18.5128 14.25 18.5128ZM2.375 30.5707V27.0505C2.375 26.2752 2.58558 25.5572 3.00675 24.8964C3.42792 24.2356 3.99079 23.7276 4.69538 23.3724C6.26024 22.6053 7.83895 22.0299 9.43152 21.6462C11.0241 21.2625 12.6302 21.0707 14.25 21.0707C15.8698 21.0707 17.4759 21.2625 19.0685 21.6462C20.661 22.0299 22.2398 22.6053 23.8046 23.3724C24.5092 23.7276 25.0721 24.2356 25.4932 24.8964C25.9144 25.5572 26.125 26.2752 26.125 27.0505V30.5707H2.375Z",
    style: {
      fill: "color(display-p3 0.3765 0.3725 0.3804)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCheck);
export default __webpack_public_path__ + "static/media/PersonCheck.212dbfd3c37de7dc316179e184f9f1ec.svg";
export { ForwardRef as ReactComponent };